var React = require('react');

function Spotify (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.254,20.508A10.254,10.254,0,1,0,0,10.254,10.258,10.258,0,0,0,10.254,20.508Zm4.163-5.421h0c-.69,0-2.868-2.417-8.989-1.162a2.639,2.639,0,0,1-.492.108.679.679,0,0,1-.091-1.348c3.386-.748,6.847-.682,9.8,1.084a.688.688,0,0,1-.226,1.318Zm1.113-2.711c-.1-.026-.068.059-.51-.173a13.4,13.4,0,0,0-9.865-1.216,1.7,1.7,0,0,1-.492.108A.841.841,0,0,1,4.5,9.436a14.979,14.979,0,0,1,11.362,1.318.862.862,0,0,1,.467.814A.8.8,0,0,1,15.53,12.376ZM3.886,5.98C7.751,4.848,13.6,5.206,17.237,7.328a1,1,0,0,1-.426,1.9h0a.952.952,0,0,1-.534-.161C13.334,7.306,8.07,6.885,4.664,7.836a1.99,1.99,0,0,1-.534.107.954.954,0,0,1-.963-.976.977.977,0,0,1,.719-.987Z","transform":"translate(0 0)","fill":"#383a36"}));
}

Spotify.defaultProps = {"width":"20.508","height":"20.508","viewBox":"0 0 20.508 20.508"};

module.exports = Spotify;

Spotify.default = Spotify;
